import { OrderStatus } from '../../types/api/stamp-order'

export const stampOrderOrderStatuses: OrderStatus[] = [
    'Создан',
    'Заказан',
    'В сборке',
    'В пути',
    'Готов к выдаче',
    'Завершен',
    'Отменен',
]
